import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useSeo } from "@/hooks/useSeo";
import { categoryMetas, contentItems } from "@/mocks/content";

const badgeColors = [
  "bg-primary-500 text-background-50",
  "bg-primary-400 text-background-50",
  "bg-accent-500 text-background-50",
];

export default function CategoryHub() {
  useSeo({
    title: "分类汇总 - 快猫",
    description: "快猫分类汇总页汇聚影视、音乐与动态资讯三大板块的精选榜单与入口，快速跳转到你感兴趣的内容分类。",
    keywords: "分类汇总,快猫分类,影视榜单,音乐榜单,资讯榜单",
  });

  return (
    <SiteLayout>
      <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-8 md:py-8">
        <Breadcrumb items={[{ label: "分类" }]} />

        <header className="mt-4">
          <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            内容分类汇总
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            快猫将内容划分为影视、音乐与动态资讯三大板块，这里为你提供各板块的精选榜单与快捷入口。
          </p>
        </header>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {categoryMetas.map((meta) => {
            const list = contentItems
              .filter((i) => i.type === meta.type)
              .sort((a, b) => b.heat - a.heat)
              .slice(0, 5);
            return (
              <section
                key={meta.type}
                className="flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${meta.icon} text-2xl`} />
                  </span>
                  <div>
                    <h2 className="font-heading text-lg font-extrabold text-foreground-950">
                      {meta.name}
                    </h2>
                    <p className="text-xs text-foreground-500">{meta.subtitle}</p>
                  </div>
                </div>
                <p className="mt-3 line-clamp-2 text-sm text-foreground-600">{meta.intro}</p>

                <ol className="mt-4 flex-1 space-y-3">
                  {list.map((item, index) => (
                    <li key={item.id}>
                      <Link
                        to={`/detail/${item.id}`}
                        className="group flex items-center gap-3 rounded-md px-2 py-1.5 transition-colors hover:bg-background-100"
                      >
                        <span
                          className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                            badgeColors[index] || "bg-background-100 text-foreground-500"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-600">
                          {item.title}
                        </span>
                        <span className="shrink-0 text-xs text-foreground-400">
                          {item.heat.toLocaleString()}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ol>

                <Link
                  to={meta.path}
                  className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  进入{meta.subtitle}
                  <i className="ri-arrow-right-line" />
                </Link>
              </section>
            );
          })}
        </div>
      </div>
    </SiteLayout>
  );
}